module.exports = __webpack_public_path__ + "img/H3.ef26b1a6.png";